import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { MeetTheTeamModel, TeamModel, TeamMemberModel } from '../model/MeetTheTeamModel';
import { MeetTheTeamController } from '../controller/MeetTheTeamController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';
import { Icon } from '@material-ui/core';
import { TextField } from 'components/input/TextField';

export class MeetTheTeamScene extends AScene<{}, MeetTheTeamModel, MeetTheTeamController> {
    protected createControlller(): MeetTheTeamController {
        return new MeetTheTeamController();
    }

    public render(): React.ReactNode {
        return (
            <div style={{ width: '100%', padding: '64px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '800px' }}>
                    <div style={{ display: 'flex' }}>
                        <div style={{ flex: 1 }}></div>
                        <div style={{ flex: 1 }}>
                            <TextField startIcon="search" label="" value={this.model.searchTerm} onChange={(newValue) => { this.controller.onSearchTermChanged(newValue) }} />
                        </div>
                    </div>
                    {this.model.teams.map((team) => {
                        return this.renderTeam(team);
                    })}
                </div>
            </div>
        )
    }

    private renderTeam(team: TeamModel) {
        return (
            <div key={"team-" + team.id} style={{ width: '100%' }}>
                {team.members.length > 0 && (
                    <>
                        <div style={{ fontSize: '18px', fontWeight: 900, color: '#aaa', marginTop: '32px' }}>{team.name}</div>
                        {team.members.map((member) => {
                            return this.renderMember(member);
                        })}
                    </>
                )}

            </div>
        )
    }

    private renderMember(member: TeamMemberModel) {
        return (
            <div key={"member-" + member.id} style={{ width: '100%', display: 'flex', backgroundColor: '#fff', boxShadow: '1px 1px 5px rgba(0,0,0,0.5)', marginBottom: '16px' }}>
                <div style={{ width: '50%', padding: '24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '80px', height: '80px', border: '5px solid #eee', borderRadius: '50%', backgroundSize: 'cover', backgroundImage: "url('/ProfilePicture?uid=" + member.id + "')" }}></div>
                        <div style={{ width: '16px' }}></div>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '22px', fontWeight: 600, color: '#222', marginBottom: '4px' }}>{member.name}</div>
                            <div style={{ fontSize: '16px', fontWeight: 400, color: '#aaa' }}>{member.position}</div>
                        </div>
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: 400, color: '#bbb', textAlign: 'justify', marginTop: '16px' }}>{member.bio}</div>
                </div>
                <div style={{ width: '50%', padding: '24px' }}>
                    {this.renderProperty("prop-email", "email", member.email)}
                    {this.renderProperty("prop-chat", "chat", member.chat)}
                    {this.renderProperty("prop-phone", "phone", "(work) " + member.phoneWork)}
                    {this.renderProperty("prop-phone2", "phone", "(home) " + member.phonePrivate)}
                    {this.renderProperty("prop-membersince", "calendar_today", member.memberSince)}
                    {this.renderProperty("prop-address", "location_on", member.address)}
                </div>
            </div>
        );
    }

    private renderProperty(key: string, icon: string, text: string) {
        return (
            <div key={key} style={{ display: 'flex', width: '100%', alignItems: 'center', marginBottom: '10px' }}>
                <Icon style={{ fontSize: '18px', color: '#666' }}>{icon}</Icon>
                <div style={{ fontSize: '16px', color: '#aaa', paddingLeft: '10px' }}>{text}</div>
            </div>
        );
    }

}

export class MeetTheTeamSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return <MeetTheTeamScene />;
    }

}